import { supabaseClient } from "supabase";

export const queryVenues = async ({
  name,
  page,
  perPage,
}: {
  name?: string;
  page?: number;
  perPage?: number;
}) => {
  let query = supabaseClient.from("venues").select("*", {
    count: "exact",
  });

  if (name) {
    query = query.ilike("name", `%${name}%`);
  }

  query = query.order("name");

  if (page && perPage) {
    query = query.range(
      (page - 1) * perPage,
      (page - 1) * perPage + perPage - 1
    );
  }

  const { data, count, error } = await query;

  if (error) {
    throw error;
  }
  return { venues: data || [], count };
};
